export default __webpack_public_path__ + "static/media/heads-05.f23b93d5.svg";